// Copy of components/transactionSearchPage/index.js on its own Redux slice for the Payments - Beta tab.
import { connect } from "react-redux";
import * as Nested from "@/util/Nested";
import TransactionSearchPageV2Beta from "./TransactionSearchPageV2Beta";
import * as CriteriaForm from "@/components/transactionSearchPage/CriteriaForm.state";
import * as FiltersForm from "@/components/transactionSearchPage/FiltersForm.state";
import _reducer, {
  CLEAR_FILTERS,
  RESET_STATE,
  mapStateToProps as transactionSearchMapState,
  mapDispatchToProps as transactionSearchMapDispatch,
} from "./TransactionSearchPageV2Beta.state";

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: transactionSearchMapState,
    mapDispatchToProps: transactionSearchMapDispatch,
  },
  {
    forms: {
      criteriaForm: {
        ...CriteriaForm,
        actionType: "TRANSACTION_SEARCH_V2_BETA_CRITERIA_FORM_ACTION",
      },
      filtersForm: {
        ...FiltersForm,
        actionType: "TRANSACTION_SEARCH_V2_BETA_FILTERS_FORM_ACTION",
      },
    },
  },
  "transactionSearchV2Beta"
);

const initialState = () => nestedReducer(undefined, { type: "@@INIT" });

const reducer = (state, action) => {
  switch (action.type) {
    case RESET_STATE:
      return initialState();
    case CLEAR_FILTERS:
      return { ...nestedReducer(state, action), forms: initialState().forms };
    default:
      return nestedReducer(state, action);
  }
};

export { reducer, mapStateToProps, mapDispatchToProps, actions };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionSearchPageV2Beta);
